import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedAuthRoutes = () => {
  const token = useSelector((state) => state.auth.token);
  if (!token) {
    return <Navigate to="/?login=1" replace />;
  }
  return <Outlet />;
};

export default ProtectedAuthRoutes;
